module.exports = __webpack_public_path__ + "static/media/leaderboard-img5.93257dbc.jpeg";